import { Injectable, inject } from '@angular/core';
import { CommandService } from '@core/services/command.service';
import { DialogService } from '@shared/services/dialog-service';

/**
 * THE RUN CHAT'S OWN DIALOG SERVICE (XAT-E-617-01), so a dialog it opens — Attach → Orbitax Drive File — uses the run
 * chat's `MatDialog`, and with it the overlay layer above the Action Monitor.
 *
 * `DialogService`'s constructor makes itself the app's command dialog service (`commandService.dialogService = this`).
 * This copy must not keep that job: every command dialog in the app would open through it, and in a container that
 * goes when the monitor closes. So the app's own copy is put back the moment this one is built — a field initializer
 * runs straight after the parent constructor.
 */
@Injectable()
export class RunChatDialogService extends DialogService {
  private readonly appDialogServiceKept = keepAppDialogService();
}

function keepAppDialogService(): boolean {
  const appDialogService = inject(DialogService, { skipSelf: true, optional: true });
  if (appDialogService) inject(CommandService).dialogService = appDialogService;
  return !!appDialogService;
}
